import { ReactElement } from 'react';
import RuleLibrary from 'pages/campaign/iteration/[iterationId]/RuleLibrary';
import RulePage from 'pages/campaign/iteration/[iterationId]/Rule';

const createSuppressionRuleRoutes = (withCampaignLoader: (component: ReactElement) => ReactElement) => ({
  path: 'suppression-rules',
  children: [
    {
      path: ':ruleId',
      element: withCampaignLoader(<RulePage ruleTypeFromRoute="S" />),
      children: [
        {
          path: 'and-clause/:andClauseNumber',
          element: withCampaignLoader(<RulePage ruleTypeFromRoute="S" />),
        },
      ],
    },
    { path: ':ruleId/library', element: withCampaignLoader(<RuleLibrary ruleType="S" />) },
    { path: ':ruleId/and-clause/:andClauseNumber/library', element: withCampaignLoader(<RuleLibrary ruleType="S" />) },
  ],
});

export default createSuppressionRuleRoutes;
